import { captureMessage } from "@sentry/react-native";
import { ScrollView } from "react-native";
import { useTailwind } from "tailwind-rn";

import Disclaimer from "./Disclaimer";
import {
  CommissionCard,
  ConsumerCard,
  ItemsCard,
  PaymentCard,
  RecurrenceCard,
  SaleSummary,
} from "./Sale";
import {
  BankCard,
  BreakdownCard,
  DepositSummary,
  StatusCard,
} from "./Withdrawal";
import ErrorView from "../../../components/ErrorView";
import LoadingView from "../../../components/LoadingView";
import useTransaction from "../contexts/TransactionContext";
import useTransactionDetailsAPI from "../contexts/TransactionDetailsAPIContext";

export default function Transaction() {
  const { transaction, isLoading } = useTransaction();
  const { onSelectCartItem, onEditBankPress } = useTransactionDetailsAPI();
  const tailwind = useTailwind();

  if (isLoading) {
    return <LoadingView />;
  }

  if (!transaction) {
    return <Error />;
  }

  function renderTransaction() {
    switch (transaction?.type) {
      case "transaction": {
        return (
          <>
            <SaleSummary summary={transaction.summary} />
            <RecurrenceCard recurrence={transaction.recurrence} />
            <ConsumerCard consumer={transaction.consumer} />
            <ItemsCard cart={transaction.cart} onItemPress={onSelectCartItem} />
            <PaymentCard payment={transaction.payment} />
            <CommissionCard commission={transaction.commission} />
          </>
        );
      }
      case "withdrawal": {
        return (
          <>
            <DepositSummary summary={transaction.summary} />
            <StatusCard status={transaction.status} />
            <BankCard
              bank={transaction.bank}
              onEditBankPress={onEditBankPress}
            />
            <BreakdownCard breakdown={transaction.breakdown} />
          </>
        );
      }
      default:
        captureMessage("Unknown transaction type", { extra: { transaction } });
        return <Error />;
    }
  }

  return (
    <ScrollView
      bounces={false}
      style={tailwind("flex-1")}
      contentContainerStyle={tailwind("p-4")}
    >
      {renderTransaction()}
      <Disclaimer />
    </ScrollView>
  );
}

function Error() {
  const tailwind = useTailwind();
  const { onWhatsappHelpPress, onErrorClose } = useTransactionDetailsAPI();

  return (
    <ErrorView
      text={`Tuvimos un error mostrandote esta venta\n\nPor favor cuentanos que hacías para poder ayudarte.`}
      style={tailwind("justify-start")}
      onWhatsappHelpButtonPress={onWhatsappHelpPress}
      onClose={onErrorClose}
    />
  );
}
